import "./App.css";
import { ToastContainer } from "react-toastify";
import Router from "./router/router";
import React, { useEffect } from "react";
import { messaging, perf } from "./firebase";
import { onMessage } from "firebase/messaging";
import { useDispatch } from "react-redux";
import { addNotification } from "./redux/notificationSlice";
import Notification from "./components/Notifications";
import TagManager from "react-gtm-module";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { trace } from "firebase/performance";

function AppContent() {
  const { isLoading } = useAuth();

  // Show loading state while authentication is in progress
  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        background: '#fff'
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  return (
    <>
      <Router />
      <ToastContainer />
      <Notification />
    </>
  );
}

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    TagManager.initialize({
      gtmId: "GTM-WXF8PB7W",
    });
    window.dataLayer.push({
      event: "order_checkout_click",
      checkout_customer_id: "test customer id",
      checkout_payment_type: "test paymeny type",
    });
  }, []);

  //  this comment  for speed  optimiztion process
  // const authenticateAnonymously = async () => {
  //   try {
  //     const userCredential = await signInAnonymously(auth); // Pass auth instance

  //     const accessToken = await userCredential.user.getIdToken();

  //     localStorage.setItem("accessToken", accessToken);
  //   } catch (error: any) {
  //     console.error("Anonymous authentication failed:", error.message);
  //   }
  // };

  // const refreshToken = async (user: any) => {
  //   try {
  //     const token = await user.getIdToken(true);
  //     localStorage.setItem("accessToken", token);
  //   } catch (error) {
  //     console.error("Token refresh failed:", error);
  //   }
  // };

  // useEffect(() => {
  //   const unsubscribe = onAuthStateChanged(auth, (user) => {
  //     if (user) {
  //       refreshToken(user);
  //     } else {
  //       authenticateAnonymously();
  //     }
  //   });

  //   return () => unsubscribe();
  // }, []);
  useEffect(() => {
    // 🔥 Initialize Performance Monitoring when app loads
    if (perf) {
      
      // 🔥 Create a custom trace for app initialization
      const appInitTrace = trace(perf, 'app_initialization');
      appInitTrace.start();
      
      // Simulate app initialization complete
      setTimeout(() => {
        appInitTrace.stop();
      }, 100);
    }
  }, []);

  const handleNotification = (
    payload: any,
    source: "foreground" | "background",
  ) => {
    if (source === "foreground") {
      const notification = {
        id: payload.messageId || Date.now(),
        title: payload.notification?.title || "Notification",
        body: payload.notification?.body || "",
        orderId: payload.data?.orderId || "",
        orderStatus: payload.data?.orderStatus || "",
        timestamp: Date.now(),
      };
      dispatch(addNotification(notification));
    }
    if (source === "background") {
      const notification = {
        id: payload.id || Date.now(),
        title: payload.notification?.title || "Notification",
        body: payload?.body || "",
        orderId: payload.id || "",
        orderStatus: payload?.orderStatus || "",
        timestamp: Date.now(),
      };
      dispatch(addNotification(notification));
    }
  };

  // Foreground messages
  useEffect(() => {
    const unsubscribe = onMessage(messaging, (payload) => {
      handleNotification(payload, "foreground");
    });

    return unsubscribe;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  // Background messages via service worker
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;

    const messageHandler = (event: MessageEvent) => {
      if (event.data?.type === "NEW_BACKGROUND_NOTIFICATION") {
        handleNotification(event.data.payload, "background");
      }
    };

    navigator.serviceWorker.addEventListener("message", messageHandler);

    navigator.serviceWorker.ready.then((registration) => {
      registration.active?.postMessage({ type: "INIT_CLIENT" });
    });

    return () => {
      navigator.serviceWorker.removeEventListener("message", messageHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
